import { useLocation } from 'react-router-dom';
import { Bell, Search, HelpCircle } from 'lucide-react';

const pageTitles = {
  '/dashboard': { title: 'Dashboard', subtitle: 'Vista general del sistema' },
  '/tenants': { title: 'Gestión de Tenants', subtitle: 'Administra todas las clínicas' },
  '/tenants/new': { title: 'Nuevo Tenant', subtitle: 'Wizard de configuración guiada' },
  '/analytics': { title: 'Analytics', subtitle: 'Métricas y estadísticas globales' },
  '/alerts': { title: 'Alertas', subtitle: 'Notificaciones del sistema' },
  '/audit-log': { title: 'Auditoría', subtitle: 'Registro de actividades' },
  '/settings': { title: 'Configuración', subtitle: 'Ajustes del sistema' },
};

export default function Header() {
  const location = useLocation();
  const currentPage = pageTitles[location.pathname] || { title: 'Central Control', subtitle: '' };

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6">
      {/* Page Title */}
      <div>
        <h1 className="text-lg font-semibold text-gray-900">{currentPage.title}</h1>
        {currentPage.subtitle && (
          <p className="text-sm text-gray-500">{currentPage.subtitle}</p>
        )}
      </div>

      {/* Actions */}
      <div className="flex items-center gap-2">
        {/* Search */}
        <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
          <Search className="w-5 h-5" />
        </button>

        {/* Notifications */}
        <button className="relative p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
          <Bell className="w-5 h-5" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>

        {/* Help */}
        <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
          <HelpCircle className="w-5 h-5" />
        </button>
      </div>
    </header>
  );
}
